/**
 * 付款 PIN 碼（電子付款的客戶在場憑證）。
 * 下單時後端對可線上收款的付款方式產生 4 位數字，隨「訂單成立」FM 送給客戶；
 * 配送員到場收款時，客戶唸給配送員，DAPP 核對後才請款／出付款碼。
 * 與 app-api PIN_PAYMENT_METHODS、dapp-api CHARGEABLE_PAYMENT_METHODS 對齊。
 */
export const PIN_PAYMENT_METHODS: readonly string[] = ["credit_card", "line_pay", "apple_pay"];

/** 快照付款方式是否屬於會產生 PIN 的電子付款（現金到付／未知方式沒有 PIN）。 */
export const needsPaymentPin = (paymentMethod: string | null | undefined): boolean =>
  paymentMethod != null && PIN_PAYMENT_METHODS.includes(paymentMethod);

/**
 * 訂單詳情是否要顯示 PIN 卡：後端只在「還在等配送員到場收款」時才回 PIN
 * （已付／改收現金／已結案回 null），前端再擋一次已完成／已取消，避免狀態剛切換、
 * 付款狀態尚未重查時殘留一張沒意義的 PIN 卡。
 */
export const shouldShowPaymentPin = ({
  paymentPin,
  uiStatus,
}: {
  paymentPin: string | null | undefined;
  uiStatus: "pending" | "waiting_for_pickup" | "delivering" | "completed" | "canceled";
}): boolean => Boolean(paymentPin) && uiStatus !== "completed" && uiStatus !== "canceled";
